import {
  PACKAGING_PENDING,
  PACKAGING_REJECTED,
  PACKAGING_FULFILLED
} from "../constants/packaging";

const initialState = {
  pending: false,
  packaging: {},
  error: {}
};

export const packaging = (state = initialState, action) => {
  switch (action.type) {
    case PACKAGING_PENDING:
      return { ...state, pending: true, error: {} };

    case PACKAGING_REJECTED:
      return { ...state, pending: false, error: action.error };

    case PACKAGING_FULFILLED:
      return {
        ...state,
        packaging: action.response,
        pending: false,
        error: {}
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/packaging.js